import NavComponent from "../lib/nav_component";

export const NavToggleComponentConfig = {
  baseHtmlClass: "nav__toggle",
  componentTypeKey: "NavToggleComponent",
  selector: ".nav__toggle",
};

export class NavToggleComponent extends NavComponent {

  // The minimum versions of the native apps that support the nav toggling feature.
  static MIN_IOS_VERSION = "2.16.43";
  static MIN_ANDROID_VERSION = "3.19.15";

  static get config() {
    return NavToggleComponentConfig;
  }

  static new(element, nav) {
    if (!element) {
      return;
    }
    return new NavToggleComponent(element, nav, NavToggleComponentConfig);
  }

  constructor(id_or_element, nav, config) {
    super(id_or_element, config);
    this.nav = nav;
    this.element.addEventListener("click", this.handleClick.bind(this));
    this.render();
  }

  render() {
    if (!this.supportNavToggling()) this.element.style.display = "none";
  }

  handleClick(event) {
    if (!this.nav) return;
    this.nav.toggleNav();
  }

  // Older versions of the native apps don't support the signal URLs that toggle the nav.
  // In that case, the nav toggle component should be hidden (see `render` method) as they will not perform the desired behaviour.
  // The platform values (ie. 'ios', 'android') can be found at `RequestContext::HasPlatform`.
  supportNavToggling() {
    if (!this.nav) return true;
    if (!this.nav.isNativeApp) return true;

    if (this.nav.nativeAppPlatform === "ios") {
      if (this.nav.nativeAppVersion.isLessThan(NavToggleComponent.MIN_IOS_VERSION)) return false;
    }

    if (this.nav.nativeAppPlatform === "android") {
      if (this.nav.nativeAppVersion.isLessThan(NavToggleComponent.MIN_ANDROID_VERSION)) return false;
    }

    return true;
  }
}
